















































































































































/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import Moment from 'moment'
import Graus from '@finx/web-repository/src/constants/Graus'
import Acomodacoes from '@finx/web-repository/src/constants/Acomodacoes'
import ViasAcesso from '@finx/web-repository/src/constants/ViasAcesso'
import TiposAtendimento from '@finx/web-repository/src/constants/TipoAtendimento'

@Component({
  props: {
    relatorio: {
      type: Object,
      default: {},
    },
  },
})

export default class ComponentRelatorioPdf extends Vue {
  today: String = ''

  data() {
    return {
      today: null,
    }
  }

  mounted() {
    this.today = Moment(new Date()).format('DD/MM/YYYY')
  }

  getAcomodacao(acomodacaoMedico) {
    let acomodacaoName = '-'

    if (acomodacaoMedico) {
      Acomodacoes.map(acomodacao => {
        if (acomodacao.id === acomodacaoMedico) acomodacaoName = acomodacao.name
      })
    }

    return acomodacaoName
  }

  getGrau(grauMedico) {
    let grauName = '-'

    if (grauMedico !== undefined) {
      Graus.map(grau => {
        if (grau.id === grauMedico) grauName = grau.name
      })
    }

    return grauName
  }

  getTipoProcedimento(tipoAtendimento) {
    if (tipoAtendimento !== null) {
      TiposAtendimento.map(tipo => {
        if (tipo.value === tipoAtendimento) tipoAtendimento = tipo.name
      })
    }

    return tipoAtendimento
  }

  getViaAcesso(viaAcesso) {
    let viaName = '-'

    if (viaAcesso) {
      ViasAcesso.map(via => {
        if (via.id == viaAcesso) viaName = via.name
      })
    }

    return viaName
  }
}

